
        Component.define('internal-real', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el           = $(el);
const $firstPhotos  = $el.find('.product-photos.product-01');
const $secondPhotos = $el.find('.product-photos.second');
const $videoThumb   = $el.find('.video-thumb');
const $slider01     = $el.find('.slider-galery-01');
const $slider02     = $el.find('.slider-galery-02');
const spaceTopPhoto = 80;

setTimeout(function() {
    const videoHeight = $videoThumb.next().find('img').height() - 3;

    $videoThumb.height(videoHeight);
}, 300);

$slider01.slick({
    dots: true,
    slidesPerRow: 5,
    rows: 7,
});

$slider02.slick({
    dots: true,
    slidesPerRow: 5,
    rows: 3,
});

$window.on('resize', function() {
    $secondPhotos.css('top', $firstPhotos.height() + spaceTopPhoto);
});

        });